import formatSortOrder from "../components/SearchResultsTable/formatSortOrder";
import { FetchDataArgs } from "../utils/fetchData";
import isFacetSearchParam from "../components/SearchForm/isFacetSearchParam";
import isRangeSearchParam from "../components/SearchForm/isRangeSearchParam";
import { normalizeIncomingQuery } from "../utils/resolveQueryParam";

/*
 * Transform front-end URL search params into args
 * to pass to getData() function.
 */
const composeRequestArgs = (
    searchParams: URLSearchParams,
    collectionId: string
): Omit<FetchDataArgs, "config"> => {
    // Prefer query from actual URL so it's correct after full-page navigation (e.g. form submit → window.location.href)
    const rawQuery =
        (typeof window !== "undefined" &&
            new URLSearchParams(window.location.search).get("query")) ||
        searchParams.get("query");
    const query = normalizeIncomingQuery(rawQuery, collectionId);

    const rawInitialOffset = Number(searchParams.get("start_rank"));
    const offset =
        rawInitialOffset && !isNaN(rawInitialOffset) ? rawInitialOffset : 1;

    const rawSortValue = searchParams.get("sort") ?? "";
    const sort = formatSortOrder(rawSortValue);

    type Facets = {
        [key: string]: string | string[];
    };
    const facets: Facets = {};
    const processedFacetParamKeys = new Set<string>();

    searchParams.forEach((paramValue, paramKey) => {
        if (
            (!isFacetSearchParam(paramKey) && !isRangeSearchParam(paramKey)) ||
            processedFacetParamKeys.has(paramKey) ||
            !paramValue.trim()
        ) {
            return;
        }
        processedFacetParamKeys.add(paramKey);

        const urlValues = searchParams
            .getAll(paramKey)
            .map((value) => value.trim())
            .filter(Boolean);

        if (urlValues.length > 1) {
            facets[paramKey] = urlValues;
        } else {
            facets[paramKey] = urlValues[0];
        }
    });

    const initialRequest = { query, offset, params: facets, sort };

    return initialRequest;
};

export default composeRequestArgs;
